import { StructuredJsonFieldDef } from '../../shared/design-system/structured-json-form.model';

export const INSURANCE_CLAIM_INVESTIGATION_FIELDS: StructuredJsonFieldDef[] = [
  {
    key: 'summary',
    type: 'textarea',
    labelKey: 'insurance.claimDetail.investigation.fields.summary',
    required: false
  },
  {
    key: 'findings',
    type: 'textarea',
    labelKey: 'insurance.claimDetail.investigation.fields.findings',
    required: false
  },
  {
    key: 'recommendedAction',
    type: 'select',
    labelKey: 'insurance.claimDetail.investigation.fields.recommendedAction',
    required: false,
    options: [
      { value: 'ContinueInvestigation', labelKey: 'insurance.claimDetail.investigation.actions.continueInvestigation' },
      { value: 'Approve', labelKey: 'insurance.claimDetail.investigation.actions.approve' },
      { value: 'Decline', labelKey: 'insurance.claimDetail.investigation.actions.decline' },
      { value: 'RequestMoreInfo', labelKey: 'insurance.claimDetail.investigation.actions.requestMoreInfo' }
    ]
  },
  {
    key: 'adjusterNotes',
    type: 'textarea',
    labelKey: 'insurance.claimDetail.investigation.fields.adjusterNotes',
    required: false
  }
];
